import axios from '@nodeModules/axios';
import { debounce } from '@nodeModules/throttle-debounce';
import { normalizeSync } from '@nodeModules/normalize-diacritics';

export const initSearchAutocomplete = (formElement) => {
	const $input = formElement.querySelector('input[type="search"]');
	let abortController = '';
	let value = '';
	let lastInputValue = '';
	let resultsList = '';

	const listEl = document.createElement('ul');
	listEl.classList.add('auto-search__list');
	formElement.appendChild(listEl);

	const loaderEl = document.createElement('li');
	loaderEl.classList.add('auto-search__loader');
	loaderEl.innerHTML = `<svg class="no-animate icon-refresh rotate"><use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="${window.location.origin}/ico/ico.svg#icon-refresh"></use></svg>`;

	const fallbackEl = document.createElement('li');
	fallbackEl.classList.add('auto-search__fallback');
	fallbackEl.innerHTML = window.searchAutocompleteStrings.fallbackMessage;

	const getSearchResults = function() {
		if (value.length > 2) {
			if (abortController === '') {
				abortController = new AbortController();
			} else {
				abortController.abort();
				abortController = new AbortController();
			}

	    	listEl.replaceChildren();
			resultsList = '';
			listEl.appendChild(loaderEl);

			axios.get(`/search?q=${value}`, {
                    signal: abortController.signal,
                })
				.then((res) => {
					if (res.data.events.length) {
						resultsList = `${resultsList}<li class="auto-search__list-item auto-search__list-item--is-label">${window.searchAutocompleteStrings.events}<div class="auto-search__list-item-line"></div></li>`;

						res.data.events.forEach(result => {
							const startingIndex = normalizeSync(result.event_name).toLowerCase().indexOf(normalizeSync(value.toLowerCase()));

							if (startingIndex > -1) {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${result.formatted_url}">${result.event_name.slice(0, startingIndex)}<strong>${result.event_name.slice(startingIndex, startingIndex + value.length)}</strong>${result.event_name.slice(startingIndex + value.length, result.event_name.length)}</a></li>`;
							} else {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${result.formatted_url}">${result.event_name}</a></li>`;
							}
						})
					}

					if (res.data.collections.length) {
						resultsList = `${resultsList}<li class="auto-search__list-item auto-search__list-item--is-label">${window.searchAutocompleteStrings.collections}<div class="auto-search__list-item-line"></div></li>`;

						res.data.collections.forEach(collection => {
							const startingIndex = normalizeSync(collection.title).toLowerCase().indexOf(normalizeSync(value.toLowerCase()));

							if (startingIndex > -1) {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${collection.formatted_url}">${collection.title.slice(0, startingIndex)}<strong>${collection.title.slice(startingIndex, startingIndex + value.length)}</strong>${collection.title.slice(startingIndex + value.length, collection.title.length)}</a></li>`;
							} else {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${collection.formatted_url}">${collection.title}</a></li>`;
							}
						})
					}

					if (res.data.brands.length) {
						resultsList = `${resultsList}<li class="auto-search__list-item auto-search__list-item--is-label">${window.searchAutocompleteStrings.brands}<div class="auto-search__list-item-line"></div></li>`;

						res.data.brands.forEach(brand => {
							const startingIndex = normalizeSync(brand.title).toLowerCase().indexOf(normalizeSync(value.toLowerCase()));

							if (startingIndex > -1) {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${brand.formatted_url}">${brand.title.slice(0, startingIndex)}<strong>${brand.title.slice(startingIndex, startingIndex + value.length)}</strong>${brand.title.slice(startingIndex + value.length, brand.title.length)}</a></li>`;
							} else {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${brand.formatted_url}">${brand.title}</a></li>`;
							}
						})
					}

					if (res.data.venues.length) {
						resultsList = `${resultsList}<li class="auto-search__list-item auto-search__list-item--is-label">${window.searchAutocompleteStrings.venues}<div class="auto-search__list-item-line"></div></li>`;

						res.data.venues.forEach(venue => {
							const startingIndex = normalizeSync(venue.title).toLowerCase().indexOf(normalizeSync(value.toLowerCase()));

							if (startingIndex > -1) {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${venue.formatted_url}">${venue.title.slice(0, startingIndex)}<strong>${venue.title.slice(startingIndex, startingIndex + value.length)}</strong>${venue.title.slice(startingIndex + value.length, venue.title.length)}</a></li>`;
							} else {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${venue.formatted_url}">${venue.title}</a></li>`;
							}
						})
					}

					if (res.data.artists.length) {
						resultsList = `${resultsList}<li class="auto-search__list-item auto-search__list-item--is-label">${window.searchAutocompleteStrings.artists}<div class="auto-search__list-item-line"></div></li>`;

						res.data.artists.forEach(artist => {
							const startingIndex = normalizeSync(artist.title).toLowerCase().indexOf(normalizeSync(value.toLowerCase()));

							if (startingIndex > -1) {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${artist.formatted_url}">${artist.title.slice(0, startingIndex)}<strong>${artist.title.slice(startingIndex, startingIndex + value.length)}</strong>${artist.title.slice(startingIndex + value.length, artist.title.length)}</a></li>`;
							} else {
								resultsList = `${resultsList}<li class="auto-search__list-item"><a class="auto-search__action" href="${artist.formatted_url}">${artist.title}</a></li>`;
							}
						})
					}

					listEl.replaceChildren();
					if (resultsList !== '') {
						listEl.innerHTML = resultsList;
					} else {
						listEl.appendChild(fallbackEl);
					}
				})
		        .catch((err) => {
		            if (err.message === 'canceled') {
		                return;
		            } else {
		            	listEl.replaceChildren();
		            }
		        });

		    lastInputValue = value;
		}
    };

	const debouncedGetSearchResults = debounce(300, getSearchResults);

	['change', 'keydown', 'paste', 'input'].forEach(function(e) {
  		$input.addEventListener(e, event => {
  			value = event.target.value;

			if (value.length > 2 && value !== lastInputValue) {
				debouncedGetSearchResults();
	  		} else if (value.length < 3) {
	  			lastInputValue = value;
	  			listEl.replaceChildren();
	  		}
  		});
	});

	$input.addEventListener('click', event => {
		if (event.target.value.length > 2 && listEl.innerHTML === '') {
			if (resultsList !== '') {
				listEl.innerHTML = resultsList;
			} else {
				listEl.appendChild(fallbackEl);
			}
		}
	});

	window.addEventListener('click', event => {
		if (event.target.closest('.auto-search__list') || event.target.closest('.js-search-autocomplete-form')) {
    		return;
		} else {
			lastInputValue = '';
			listEl.replaceChildren();
		}
	});
};
